"use client";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-8 w-full">
      <div className="max-w-screen-xl mx-auto flex flex-col items-center space-y-3 text-center">
        <div>
          <p>Carer AI</p>
        </div>

        <div>
          <p>Redmond, US | Gurgaon, India</p>
        </div>

        <p>+91 7701 858 315</p>

        <div>
          <p>Copyright © 2024 Carer Healthcare - All Rights Reserved</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
